"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_DOCUMENT = exports.GET_DOCUMENT = "GET_DOCUMENT";
var QUERY_DOCUMENTS = exports.QUERY_DOCUMENTS = "QUERY_DOCUMENTS";
var UPSERT_DOCUMENT = exports.UPSERT_DOCUMENT = "UPSERT_DOCUMENT";
var DELETE_DOCUMENT = exports.DELETE_DOCUMENT = "DELETE_DOCUMENT";
var FIND_DOCUMENT = exports.FIND_DOCUMENT = "FIND_DOCUMENT";
var QUERY_SHAREABLE_DOCUMENTS = exports.QUERY_SHAREABLE_DOCUMENTS = "QUERY_SHAREABLE_DOCUMENTS";
var SHARE_UNSHARE_DOCUMENTS = exports.SHARE_UNSHARE_DOCUMENTS = "SHARE_UNSHARE_DOCUMENTS";